import { Component, OnInit, inject, signal, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import SharedModule from 'app/shared/shared.module';
import HasAnyAuthorityDirective from 'app/shared/auth/has-any-authority.directive';
import { VERSION } from 'app/app.constants';
import { AccountService } from 'app/core/auth/account.service';
import { LoginService } from 'app/login/login.service';
import { ProfileService } from 'app/layouts/profiles/profile.service';
import { EntityNavbarItems } from 'app/entities/entity-navbar-items';
import NavbarItem from './navbar-item.model';
import {TicketService} from "../../entities/ticket/service/ticket.service";
import { SocketService } from 'app/shared/socket.service';
import { AlertService } from 'app/core/util/alert.service';

@Component({
  standalone: true,
  selector: 'jhi-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  imports: [RouterModule, SharedModule, HasAnyAuthorityDirective],
})
export default class NavbarComponent implements OnInit, OnDestroy {
  inProduction?: boolean;
  isNavbarCollapsed = signal(true);
  openAPIEnabled?: boolean;
  version = '';
  account = inject(AccountService).trackCurrentAccount();
  entitiesNavbarItems: NavbarItem[] = [];
  numberOfRequestedCar: number = 0;
  private isAuthenticated = false;
  currentUserRoles: string[] = [];

  private loginService = inject(LoginService);
  private profileService = inject(ProfileService);
  private ticketService = inject(TicketService);
  private router = inject(Router);
  private socketService = inject(SocketService);
  private alertService = inject(AlertService);
  private accountService = inject(AccountService);
  private lastProcessedId: number | null = null;

  constructor() {
    if (VERSION) {
      this.version = VERSION.toLowerCase().startsWith('v') ? VERSION : `v${VERSION}`;
    }
  }

  ngOnInit(): void {
    this.entitiesNavbarItems = EntityNavbarItems;
    this.profileService.getProfileInfo().subscribe(profileInfo => {
      this.inProduction = profileInfo.inProduction;
      this.openAPIEnabled = profileInfo.openAPIEnabled;
    });
    this.ticketService.getNumberOfRequestedCar().subscribe(numberOfRequestedCar => {
      this.numberOfRequestedCar = numberOfRequestedCar;
      console.log('Number of requested car: ', this.numberOfRequestedCar);
    });
    this.updateRequestedCarCount();

    this.accountService.getAuthenticationState().subscribe(account => {
      this.isAuthenticated = !!account;
      if (account) {
        this.currentUserRoles = account.authorities || [];
      }
    });

    this.socketService.getMessages().subscribe((message) => {
      console.log('Received socket message:', message);

      if (this.isAuthenticated && message) {
        switch(message.data.action) {
          case 'requestCar':
            const ticketId = message.data.data.ticketNo;
            if (ticketId && this.lastProcessedId !== ticketId) {
              this.lastProcessedId = ticketId;
              this.ticketService.getNumberOfRequestedCar().subscribe(numberOfRequestedCar => {
                this.numberOfRequestedCar = numberOfRequestedCar;
                this.alertService.addAlert({
                  type: 'info',
                  message: `<strong>Car Requested TicketNo</strong>: ${ticketId}`,
                  timeout: 10000,
                  toast: true,
                  position: 'bottom left'
                });
              });
            }
            break;

          case 'updateCar':
            console.log('Update car', "alo");
            this.updateRequestedCarCount();
            break;
        }
      }
    });
  }

  ngOnDestroy() {
    // Cleanup WebSocket connection when component is destroyed
  }

  collapseNavbar(): void {
    this.isNavbarCollapsed.set(true);
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  logout(): void {
    this.collapseNavbar();
    this.loginService.logout();
    this.router.navigate(['']);
  }

  toggleNavbar(): void {
    this.isNavbarCollapsed.update(isNavbarCollapsed => !isNavbarCollapsed);
  }

  private updateRequestedCarCount(): void {
    this.ticketService.getNumberOfRequestedCar().subscribe({
      next: (count) => {
        this.numberOfRequestedCar = count;
        console.log('Updated requested car count:', this.numberOfRequestedCar);
      },
      error: (error) => {
        console.error('Error getting requested car count:', error);
      }
    });
  }

  hasRole(roles: string[]): boolean {
    return roles.some(role => this.currentUserRoles.includes(role));
  }
}
